export type DrawerMode =
    | 'over'
    | 'side';

export type DrawerPosition =
    | 'left'
    | 'right';
